<template>
  <section>
    <div class="personal-center-form__section">

      <div v-if="Number(userInfo.crmCustomerType) === 1">
        <h1 class="personal-center-form__title">实名认证</h1>
        <div class="personal-center-form__main">
          <el-row :gutter="0" class="personal-center-form__form" style="padding-bottom:0;">
            <el-col :span="16">
              <el-form :label-width="'50%'" :model="realAuthFormModel" :rules="rules" ref="realAuthForm">
                <el-form-item label="请上传身份证正反面"></el-form-item>
              <el-form-item>
			<ul class="file-list__item-list1" >
	            <template v-for="file in idCardFrontId" >
	              <li class="file-list__item-preview2">
	                <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${tokenId}`">
	                <div class="file-list__item-delete"
	                     @click.stop="deleteUploadedFile2(file)" v-show="canDel">
	                  <i class="el-icon-close"></i>
	                </div>
	              </li>
	            </template>
	            <!--element-ui上传控件不支持IE9，使用webuploader插件替代 @mousedown="changeFileType(file.filesId)"-->
	            <li id="reder" class="file-list__select-file2"
	                v-show="idCardFrontId.length < 1" style="width: 270px;height: 200px;">
	            </li>
          </ul>   
          </el-form-item>  

          <!-- 身份证反面 -->
          <el-form-item >
	            <template v-for="file in idCardBackId">
	              <li class="file-list__item-preview2" style="margin-top: -222px;margin-left: 155px;">
	                <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${tokenId}`">
	                <div class="file-list__item-delete"
	                     @click.stop="deleteUploadedFile3(file)" v-show="canDel">
                       <i class="el-icon-close"></i>
	                </div>
	              </li>
	            </template>
		
	            <li id="reder2" class="file-list__select-file2"
	                v-show="idCardBackId.length < 1" style="width: 270px;height: 200px;margin-top: -222px;margin-left: 150px;">
	              <!-- <i class="el-icon-plus"></i> -->
	            </li>
         
          </el-form-item>  
           <el-form-item label="姓名" prop="name" ref="name">
                  <el-input placeholder="请输入姓名" v-model="realAuthFormModel.name" :disabled="isEditable"></el-input>
                </el-form-item>
                <el-form-item label="身份证号码" prop="idno" ref="idno">
                  <el-input placeholder="请输入身份证号码" v-model="realAuthFormModel.idno" :disabled="isEditable"
                            :maxlength="IDMaxLength"></el-input>
                </el-form-item>
                <!--<el-form-item label="开户名称">{{bankUserName}}</el-form-item>-->
                <!-- <el-form-item label="银行所属区域" prop="bankRegion" ref="region">
                  <el-cascader :options="regionData" :props="bankRegionProps" :disabled="isEditable"
                               @active-item-change="changeRegionData"
                               v-model="realAuthFormModel.bankRegion" v-if="regionData"
                               placeholder="请选择银行所属区域"></el-cascader>
                </el-form-item>
                <el-form-item label="开户银行" prop="bankName" ref="bankName">
                  <el-select v-model="realAuthFormModel.bankName" filterable remote :remote-method="searchBankName"
                             :disabled="isEditable" @change="changeBankName" placeholder="请输入关键字选择开户银行">
                    <el-option v-for="item in bankNameData" :key="item.value" :label="item.text"
                               :value="item.value"></el-option>
                  </el-select>
                </el-form-item> -->
                <!-- <el-form-item label="支行名称" prop="bankBranchName" ref="branchName">
                  <el-input type="text" v-model="realAuthFormModel.bankBranchName" :disabled="isEditable"
                            placeholder="请输入支行名称" :maxlength="35"></el-input>
                </el-form-item>
                <el-form-item label="开户账户" prop="bankAccountName" ref="accountName">
                  <div class="showFormatBankAccountName" v-if="isShowFormatBANBox">
                    <span>{{bankAccountNameSpace}}</span>
                  </div>
                  <el-input type="text" v-model="realAuthFormModel.bankAccountName" :disabled="isEditable"
                            @change="addBankcardNumSpaces" @focus="showFormatBANBox" :maxlength="23"
                            placeholder="请输入开户账户"></el-input>
                </el-form-item> -->

                <!--<el-form-item label="银行卡号" prop="cardno">-->
                  <!--<el-select placeholder="请选择银行卡号" :style="{width: '100%'}" v-model="realAuthFormModel.cardno">-->
                    <!--<el-option v-for="item in bankList" :key="item.bankAccountName" :label="item.bankAccountName"-->
                               <!--:value="item.bankAccountName"-->
                               <!--@click.native="selectCardNO(item.bankAccountName)"></el-option>-->
                  <!--</el-select>-->
                <!--</el-form-item>-->

                <!-- <el-form-item label="银行预留手机号" prop="mobile" ref="mobile">
                  <el-input placeholder="请输入手机号" v-model="realAuthFormModel.mobile" :maxlength="11"
                            :disabled="isEditable"></el-input>
                </el-form-item> -->

               
                <div v-if="!isEditable">
                 <!-- <el-form-item label="签约号码" prop="proNumber">
                    <el-input placeholder="请输入您的签约号" v-model="realAuthFormModel.proNumber"
                              :disabled="stateCode === 3 ? true : false" :maxlength="16"></el-input>
                  </el-form-item>-->
                  <!-- <el-form-item label="短信验证码" prop="SMSCode" class="SMS-cont" v-show="!isAuth && auditState !== '-1' && auditState !== '1'">
                    <el-input placeholder="请输入短信验证码"  v-model="realAuthFormModel.SMSCode"
                              :disabled="isEditable || isGetCode" :maxlength="6" @blur="inputBlurFn('SMSCode')"></el-input>
                    <el-button type="primary" style="background:#EB662B;" size="mini" class="el-button-sms-code" @click="getSMSCode"
                               >{{SMSCodeBtn.text}}
                    </el-button>
                  </el-form-item> -->
                  <!-- <el-form-item prop="hasReadContract" class="protocol_cont text-center bankContract" v-show="!isAuth && auditState !== '-1' && auditState !== '1'">
                    <el-checkbox-group v-model="realAuthFormModel.hasReadContract" style="font-size:1;">
                      <el-checkbox class="step1__has-read-loan-contract" label="我已阅读并同意"></el-checkbox>
                      <a class="step1__show-loan-contract" @click.prev="showBankContract">《银行卡协议》</a>
                    </el-checkbox-group>
                  </el-form-item> -->
                </div>
              </el-form>
            </el-col>
          </el-row>
          <div class="tips_info el-icon-information">如有信息出错，请联系管理员修改</div>
          <div class="text-center">
            <el-button type="primary" style="margin-bottom: 25px;" :loading="isSaving" @click="submitForm"
                       v-if="!isAuth && auditState !== '-1' && auditState !== '1'">开始认证
            </el-button>
            <el-button type="primary" :loading="isSaving" class="personal-center-form__alreadyAuth"
                       :disabled="auditState === '-1'" @click="submitForm" v-if="auditState == '-1'">已提交
            </el-button>
            <el-button type="primary" :loading="isSaving" class="personal-center-form__alreadyAuth"
                       :disabled="auditState === '1'" @click="submitForm" v-if="auditState == '1'">已认证
            </el-button>            
          </div>
        </div>
      </div>
      <div v-if="Number(userInfo.crmCustomerType) === 2">
        <h1 class="personal-center-form__title">企业认证</h1>
        <div class="personal-center-form__main">
               
          <el-row :gutter="0" class="personal-center-form__form" style="padding-bottom:0;">
            <el-col :span="16">
              <el-form :label-width="'50%'" :model="enterpriseInfoFormModel" :rules="rules" ref="realAuthForm">
                <el-form-item label="企业名称" prop="customerName">
                  <el-input type="text" placeholder="请输入客户名称" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.customerName"></el-input>
                </el-form-item>
                <el-form-item label="营业执照号" prop="enterpriseNumber">
                  <el-input type="text" placeholder="请输入营业执照号" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseNumber"></el-input>
                </el-form-item>
               <!--  <el-form-item label="所属行业" prop="enterpriseIndustry">
                  <el-select v-model="enterpriseInfoFormModel.enterpriseIndustry" placeholder="请选择所属行业" :disabled="isEditable">
                    <el-option
                      v-for="item in belongIndustryList"
                      :key="item.itemValue"
                      :label="item.itemName"
                      :value="item.itemValue">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="企业规模" prop="enterpriseScale">
                  <el-select v-model="enterpriseInfoFormModel.enterpriseScale" placeholder="请选择企业规模" :disabled="isEditable">
                    <el-option
                      v-for="item in corporationscaleList"
                      :key="item.itemValue"
                      :label="item.itemName"
                      :value="item.itemValue">
                    </el-option>
                  </el-select>
                </el-form-item> 
                <el-form-item label="省份" prop="province">
                  <el-select @change="getCityList" v-model="enterpriseInfoFormModel.province" placeholder="请选择省份" :disabled="isEditable">
                    <el-option
                      v-for="item in provinceList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="城市" prop="city">
                  <el-select v-model="enterpriseInfoFormModel.city" placeholder="请选择城市" :disabled="isEditable">
                    <el-option
                      v-for="item in cityList"
                      :key="item.code"
                      :label="item.name"
                      :value="item.code">
                    </el-option>
                  </el-select>
                </el-form-item>
                -->
                <el-form-item label="办公地址" prop="enterpriseOfficeAddress">
                  <el-input type="textarea" placeholder="请输入办公地址" :disabled="isEditable" :maxlength='30' resize="none" :rows="2"
                            v-model="enterpriseInfoFormModel.enterpriseOfficeAddress"></el-input>
                </el-form-item>
                <!-- <el-form-item v-if="!isEditable" label="注册人类型" :required="true" prop="userType">
                  <el-radio-group v-model="enterpriseInfoFormModel.userType" :disabled="isEditable">
                    <el-radio :label="2">法定代表人注册</el-radio>
                    <el-radio :label="1">代理人注册</el-radio>
                  </el-radio-group>
                </el-form-item> -->
                <el-form-item :label="Number(enterpriseInfoFormModel.userType) === 2 ? '法定代表人' : '代理人'" :required="true" prop="enterpriseLegalUser">
                  <el-input type="text" :placeholder="Number(enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人' : '请输入代理人'" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseLegalUser"></el-input>
                </el-form-item>
                <el-form-item :label="Number(enterpriseInfoFormModel.userType) === 2 ? '法定代表人身份证号' : '代理人身份证号'" :required="true" prop="enterpriseLegalIdNo">
                  <el-input type="text" :placeholder="Number(enterpriseInfoFormModel.userType) === 2 ? '请输入法定代表人身份证号' : '请输入代理人身份证号'" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseLegalIdNo"></el-input>
                </el-form-item>
                <el-form-item :label="Number(enterpriseInfoFormModel.userType) === 2 ? '法定代表人联系电话':'代理人联系电话'" :required="true" prop="enterpriseLegalUserPhone">
                  <el-input type="tel" :placeholder="Number(enterpriseInfoFormModel.userType) === 2 ?'请输入法定代表人联系电话':'请输入法定代表人联系电话'" :disabled="isEditable" :maxlength="11"
                            v-model="enterpriseInfoFormModel.enterpriseLegalUserPhone"></el-input>
                </el-form-item>
                <el-form-item label="经办人" :required="true" prop="enterpriseAgentUser">
                  <el-input type="text" placeholder="请输入经办人" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseAgentUser">
                  <el-button slot="append" icon="el-icon-search" @click="setAgent">同法定代表人</el-button>                            
                            </el-input>
                  
                </el-form-item>
                <el-form-item label="经办人身份证号" :required="true" prop="enterpriseAgentIdNo">
                  <el-input type="text" placeholder="请输入经办人身份证号" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseAgentIdNo">
                            </el-input>
                </el-form-item>
                <el-form-item label="经办人联系电话" :required="true" prop="enterpriseAgentContact">
                  <el-input type="tel" placeholder="请输入经办人联系电话" :disabled="isEditable" :maxlength="11"
                            v-model="enterpriseInfoFormModel.enterpriseAgentContact"></el-input>
                </el-form-item>                                
                <el-form-item label="企业注册类型" prop="registrationType">
                  <el-radio-group v-model="enterpriseInfoFormModel.registrationType" :disabled="isEditable">
                    <el-radio :label="1">多证合一</el-radio>
                    <el-radio :label="0">组织机构代码证号</el-radio>
                  </el-radio-group>
                </el-form-item>
                <el-form-item :label="Number(enterpriseInfoFormModel.registrationType) === 0?'组织机构代码证号':'社会信用代码号'" :required="true" prop="enterpriseOrganizingNumber">
                  <el-input type="text" :placeholder="Number(enterpriseInfoFormModel.registrationType) === 0?'请输入组织机构代码证号':'请输入社会信用代码号'" :disabled="isEditable"
                            v-model="enterpriseInfoFormModel.enterpriseOrganizingNumber"></el-input>
                </el-form-item>
                <el-form-item label="请上传营业执照"></el-form-item>
                <el-form-item>
                      <ul class="file-list__item-list">
                        <template v-for="file in sysFileIds">
                          <li
                              class="file-list__item-preview" style="width: 50%;margin-left: 1px;">
                            <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${tokenId}`"
                                >
                            <div class="file-list__item-delete"
                                @click.stop="deleteUploadedFile(file)" v-show="canDel">
                              <i class="el-icon-close"></i>
                            </div>
                          </li>
                        </template>
                        <!--element-ui上传控件不支持IE9，使用webuploader插件替代 @mousedown="changeFileType(file.filesId)"-->
                        <li id="picker" class="file-list__select-file"
                            v-show="sysFileIds.length < 1" style="width: 50%;margin-left: 1px;">
                          <i class="el-icon-plus"></i>
                        </li>
                    </ul>   
                </el-form-item>  
                <el-form-item label="请上传法定代表人身份证正反面" style="width: 80%;"></el-form-item>
                <el-form-item>
                  <ul class="file-list__item-list1" >
                      <template v-for="file in idCardFrontId" >
                        <li class="file-list__item-preview2">
                          <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${tokenId}`">
                          <div class="file-list__item-delete"
                              @click.stop="deleteUploadedFile2(file)" v-show="canDel">
                            <i class="el-icon-close"></i>
                          </div>
                        </li>
                      </template>
                      <!--element-ui上传控件不支持IE9，使用webuploader插件替代 @mousedown="changeFileType(file.filesId)"-->
                      <li id="reder3" class="file-list__select-file2"
                          v-show="idCardFrontId.length < 1" style="width: 270px;height: 200px;">
                      </li>
                  </ul>   
                </el-form-item>  
                  <!-- 身份证反面 -->
                  <el-form-item >
                      <template v-for="file in idCardBackId">
                        <li class="file-list__item-preview2" style="margin-top: -222px;margin-left: 155px;">
                          <img :src="`${ajaxBaseUrl}/mobile/crmCustomerAttachInfoController/getFile.ht?fileId=${file.fileId}&tokenId=${tokenId}`">
                          <div class="file-list__item-delete"
                              @click.stop="deleteUploadedFile3(file)" v-show="canDel">
                              <i class="el-icon-close"></i>
                          </div>
                        </li>
                      </template>
                      <li id="reder4" class="file-list__select-file2"
                          v-show="idCardBackId.length < 1" style="width: 270px;height: 200px;margin-top: -222px;margin-left: 150px;">
                      </li>
                  </el-form-item>                                 
              </el-form>
            </el-col>
          </el-row>
          <div class="tips_info el-icon-information">如有信息出错，请联系管理员修改</div>
          <!-- <div class="tips_info el-icon-information" v-if="approvalInfo != null || approvalInfo != ''">审核意见：<span style="color:red">{{approvalInfo}}</span></div> -->
          <div class="text-center">
            <el-button type="primary" :loading="isSaving" style="margin-bottom: 25px;" @click="submitForm"
                       v-if="stateCode == 1">企业认证
            </el-button>
            <el-button type="primary" :loading="isSaving" style="margin-bottom: 25px;" @click="submitForm2"
                       v-if="stateCode == 0">法定代表人认证
            </el-button>
            <el-button type="primary" :loading="isSaving" class="personal-center-form__alreadyAuth"
                       :disabled="stateCode === 2" @click="submitForm" v-if="stateCode == 2">待审核
            </el-button>
            <el-button type="primary" :loading="isSaving" class="personal-center-form__alreadyAuth"
                       :disabled="stateCode === 3" @click="submitForm" v-if="stateCode == 3">已认证
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <el-dialog class="success-modal" top="23%" :visible="realNameSuccessModal.show" :before-close="beforeCloseRealNameSuccessModal"
               :close-on-click-modal="false" @close="closeRealNameSuccessModal">
      <div class="success-modal__text">{{realNameSuccessModal.content}}</div>
    </el-dialog>     
  </section>
</template>
<script>
  import api from '../../vuex/api';
  import _ from 'lodash';
  import 'webuploader/css/webuploader.css';
  import Webuploader from 'webuploader';
  import {mapGetters, mapActions, mapMutations} from 'vuex';
  import * as types from '../../vuex/types';
  import { VERIFY_ENTERPRISE_ORGANIZING_NUMBER } from '../../vuex/types';

  export default {
    data () {
      const assignValidator = (type, trigger = 'blur') => Object.assign({
        required: true,
        trigger
      }, {
        validator: (rules, value, callback, source, options) => {
          this.$store.dispatch(type, {rules, value, callback, source, options});
        }
      });
      return {
        realNameSuccessModal:{
          show:false,
          content:''
        },
        tokenId: localStorage.getItem('dl_tokenId_bl'),
        sysFileIds: [],
        idCardFrontId: [],
        idCardBackId: [],
        canDel: true,
        indexCode: '',
        IDMaxLength: 18,
        isEditable: false,
        isSaving: false,
        isAuth: false,
        auditState: '',
        rules: {
          // cardno: [{required: true, message: '请选择银行卡号', trigger: 'change'}],
          mobile: [assignValidator(types.VERIFY_CELLPHONE)],
          name: [assignValidator((types.VERIFY_CHN_NAME))],
          idno: [assignValidator(types.VERIFY_ID_CARD_NUM)],
          enterpriseNumber: [assignValidator(types.VERIFY_ENTERPRISE_NUMBER)],
          SMSCode: [{required: true, message: '请输入收到的短信验证码', trigger: 'blur'}],
          enterpriseLegalUser: [assignValidator((types.VERIFY_CHN_NAME))],
          enterpriseLegalUserPhone: [assignValidator(types.VERIFY_CELLPHONE)],
          enterpriseLegalIdNo: [assignValidator(types.VERIFY_ID_CARD_NUM)],
          enterpriseAgentUser: [assignValidator((types.VERIFY_CHN_NAME))],
          enterpriseAgentIdNo: [assignValidator(types.VERIFY_ID_CARD_NUM)],
          enterpriseAgentContact:[assignValidator(types.VERIFY_CELLPHONE)],
          customerName: [{
            required: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('客户名称不能为空'));
              } else {
                callback();
              }
            }
          }],
          enterpriseOrganizingNumber: [{
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('组织机构代码证号不能为空'));
              } else {
                callback();
              }
            }
          }],
            enterpriseOfficeAddress: [{
            trigger: 'blur',
            required: true,
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('办公地址不能为空'));
              } else {
                callback();
              }
            }
          }],
          userType: [{
            require: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (_.trim(value) === '') {
                callback(new Error('请选择'));
              } else {
                callback();
              }
            }
          }],
          bankName: [{
	        required: true,
	        trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value.trim() === '') {
                callback(new Error('请输入开户银行'));
              } else {
                callback();
              }
            }
          }],
          bankBranchName: [{
		    required: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              console.log(value);
              if (value.trim() === '') {
                callback(new Error('请输入支行名称'));
              } else {
                callback();
              }
            }
          }],
          bankAccountName: [{
		    required: true,
            trigger: 'blur',
            validator: (rules, value, callback) => {
              if (value) {
                value = value.replace(/\s/g, '');
              }
              this.isShowFormatBANBox = false;
              if (value.trim() === '') {
                callback(new Error('请输入开户账户'));
              } else if (_.isNaN(Number(value))) {
                callback(new Error('请输入正确的银行卡账户号码'));
              } else if (value.length < 12) {
                callback(new Error('银行卡账户号码不能小于12位'));
              } else if (value.length > 30) {
                callback(new Error('银行卡账户号码不能大于30位'));
              } else {
                callback();
              }
            }
          }],
          hasReadContract: [{
            trigger: 'change',
            validator: (rules, value, callback) => {
              if (!value) {
                callback(new Error('必须阅读并同意《银行卡协议》'));
              } else {
                callback();
              }
            }
          }],
          province: [{
            type: 'string',
            required: true,
            message: '请选择省份',
            trigger: 'change'
          }],
          city: [{
            type: 'string',
            required: true,
            message: '请选择城市',
            trigger: 'change'
          }],
          enterpriseScale: [{
            type: 'string',
            required: true,
            message: '请选择企业规模',
            trigger: 'change'
          }],
          enterpriseIndustry: [{
            type: 'string',
            required: true,
            message: '请选择所属行业',
            trigger: 'change'
          }]
        },
        SMSCodeBtn: {
          btnState: false,
          text: '获取验证码'
        },
        bankAccountNameSpace: '',
        isGetCode: true,
        enterpriseInfoFormModel: {
          authId: '',
          customerName: '',
          enterpriseNumber: '',
          enterpriseOfficeAddress: '',
          enterpriseLegalUser: '',
          enterpriseLegalUserPhone: '',
          enterpriseLegalIdNo: '',
          userType: 2,
          registrationType: 1,
          enterpriseOrganizingNumber: '',
          enterpriseAgentUser:'',
          enterpriseAgentIdNo:'',
          enterpriseAgentContact:'',
          province:'',
          city:'',
          enterpriseIndustry:'',
          enterpriseScale:''
        },
        approvalInfo: null,
        bankUserName: '',
        bankRegionProps: {
          value: 'code',
          label: 'name',
          children: 'children'
        },
        bankNameData: [],
        isShowFormatBANBox: false,
        selectedBankcard: {},
        provinceList: [],
        cityList: [],
        belongIndustryList: [],
        corporationscaleList: [],
        provinceCode: ''
      };
    },
    computed: {
      ...mapGetters({
        regionData: types.GET_REGION_DATA,
        myInfo: types.GET_MY_INFO,
        userInfo: types.GET_USER,
        realAuthFormModel: types.GET_REAL_NAME_AUTH_ALL_INFO,
        bankList: types.GET_BANK_LIST,
        stateCode: types.GET_REAL_NAME_STATE,
        ajaxBaseUrl: types.GET_AJAX_BASE_URL
      })
    },
    methods: {
      ...mapMutations({
        setRealNameAuthInfo: types.SET_REAL_NAME_AUTH_ALL_INFO,
        setBankList: types.SET_BANK_LIST,
        updateBankCardNum: types.UPDATE_BANK_CARD_NUM,
        setRealNameState: types.SET_REAL_NAME_STATE
      }),
      ...mapActions({
        setBankContract: types.SET_BANK_STATE,
        getProvinceData: types.SET_PROVINCE_DATA,
        getCityAndDistrictData: types.SET_CITY_AND_DISTRICT_DATA,
        getRealNameAuthData: types.GET_REAL_NAME_AUTH_DATA,
        setSuccessMessage: types.SET_SUCCESS_MESSAGE,
        setFailMessage: types.SET_FAIL_MESSAGE
      }),
      // 获取省份列表
      getProvinceList () {
        api.getProvinceList().then((res) => {
          const resData = res.data
          if (resData.code == 0) {
            this.provinceList = resData.result.provinceList;
          } else {
            this.setFailMessage({
              show: true,
              content: resData.msg || "获取省份列表信息失败",
            });
          }
        });
      },
      // 获取城市列表
      getCityList (parentCode) {
        if (parentCode == undefined || parentCode == '') {
          return;
        }
        const param = {
          parentCode: parentCode
        };
        api.getCityList(param).then((res) => {
          const resData = res.data
          if (resData.code == 0) {
            this.cityList = resData.result.cityList;
            if(this.cityList != null && this.cityList.length != 0) {
              if (parentCode != this.provinceCode) {
                this.enterpriseInfoFormModel.city = this.cityList[0].code;
              }
            } else {
              this.enterpriseInfoFormModel.city = '';
            }
            this.provinceCode = parentCode
          } else {
            this.setFailMessage({
              show: true,
              content: resData.msg || "获取城市列表信息失败",
            });
          }

        });
      },
      // 获取所属行业
      getBelongIndustryList () {
        api.getBelongIndustryList().then((res) => {
          const resData = res.data
          if (resData.code == 0) {
            this.belongIndustryList = resData.result.belongIndustryList;
          } else {
            this.setFailMessage({
              show: true,
              content: resData.msg || "获取所属行业信息失败",
            });
          }
        });
      },
      // 获取企业规模
      getCorporationscaleList () {
        api.getCorporationscaleList().then((res) => {
          const resData = res.data
          if (resData.code == 0) {
            this.corporationscaleList = resData.result.corporationscaleList;
          } else {
            this.setFailMessage({
              show: true,
              content: resData.msg || "获取企业规模信息失败",
            });
          }
        });
      },
      inputBlurFn (prop) {
        if (event.srcElement) {
          this.realAuthFormModel[prop] = event.srcElement.value;
        }
      },
      getUrlKey(name){
　　    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
      },
      beforeCloseRealNameSuccessModal(){
        this.realNameSuccessModal.show = false;
      },
      closeRealNameSuccessModal(){
        this.$router.go(0);
      },
      searchBankName (bankName) {
        const params = {
          token: this.userInfo.token
        };
        if (!this.isAuth) {
          if (!bankName) {
            this.bankNameData = [];
            return;
          }
          params.bankName = bankName;
        }
        api.getBankcardSelectData(params).then((res) => {
          const resData = res.data;
          if (Number(resData.code) === 0) {
            this.bankNameData = resData.bankNameList;
          } else {
//            this.setFailMessage({
//              show: true,
//              content: resData.result
//            })
            this.bankNameData = [];
          }
        });
      },
      showBankContract () {
        this.setBankContract({
          show: true
        });
      },
      changeRegionData (val) {
        this.getCityAndDistrictData({val});
      },
      showFormatBANBox () {
        this.bankAccountNameSpace = this.realAuthFormModel.bankAccountName;
        this.addBankcardNumSpaces();
        this.isShowFormatBANBox = true;
      },
      addBankcardNumSpaces () {
//        直接在input里面格式化有多个bug，暂无解决方案，主要是dom刷新问题
        const that = this;
        // vue 1里面可以给v-model上filter，2没有了这个特性，只能设法变通了
        const spaceRE = /(\s*)/g;  // 正则-所有空格
        const spaceEndRE = /(\s*$)/g;  // 正则-末位空格
        that.bankAccountNameSpace = that.realAuthFormModel.bankAccountName;
        that.bankAccountNameSpace = that.bankAccountNameSpace.replace(spaceRE, '').replace(/(\d{4})(?=\d)/g, '$1 ').replace(spaceEndRE, ''); // 替换末位空格
      },
      changeBankName (val) {
        const selecteBank = _.find(this.bankNameData, item => item.value === val);
        // element ui 的坑，直接设置form的data会导致数据错乱，text和value搞不清，银行卡名称怎么保存都不对
        // v-model绑定的是value，但是点击修改设置了value之后就会把value当成text显示
        if (this.bankNameData.length && !_.isEmpty(val)) {
          this.selectedBank = {
            bankName: selecteBank.text,
            bankNameValue: selecteBank.value
          };
        }
      },
      setAgent(){//设置经办人信息同法人信息
        this.enterpriseInfoFormModel.enterpriseAgentUser = this.enterpriseInfoFormModel.enterpriseLegalUser;
        this.enterpriseInfoFormModel.enterpriseAgentIdNo = this.enterpriseInfoFormModel.enterpriseLegalIdNo;
        this.enterpriseInfoFormModel.enterpriseAgentContact = this.enterpriseInfoFormModel.enterpriseLegalUserPhone;
      },
      submitForm () {
        this.$refs.realAuthForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            this.isSaving = true;
            if (Number(this.userInfo.crmCustomerType) === 1) {
              const idCardFrontIdEnCode = this.idCardFrontId ? encodeURIComponent(JSON.stringify(this.idCardFrontId)) : '';
              const idCardBackIdEnCode = this.idCardBackId ? encodeURIComponent(JSON.stringify(this.idCardBackId)) : '';
              /* api.saveBankcardInfo({
                token: this.userInfo.token,
                customerId: this.userInfo.crmCustomerId,
                bankType: 1,
                bankUserName: `${this.realAuthFormModel.name}`.replace(/\s/g, ''),
                bankAccountName: `${this.realAuthFormModel.bankAccountName}`.replace(/\s/g, ''),
                bankName: this.realAuthFormModel.bankName,
                bankBranchName: this.realAuthFormModel.bankBranchName,
                bankAccountId: this.realAuthFormModel.bankAccountId,
                bankCounty: this.realAuthFormModel.bankRegion[2],
                bankProvince: this.realAuthFormModel.bankRegion[0],
                bankCity: this.realAuthFormModel.bankRegion[1]
  
              }).then((res) => { 
                if (Number(res.data.code) === 0) {*/
	                api.authPersonSignAgreement({
	                  //proNumber: this.realAuthFormModel.proNumber,
	                  //bankAccount: this.realAuthFormModel.bankAccountName,
	                  bankAccountOwner: this.realAuthFormModel.name,
	                  //idCard: this.realAuthFormModel.idno,
	                  customerId: this.userInfo.crmCustomerId,
	                  //vCode: this.realAuthFormModel.SMSCode,
	                  indexCode: this.indexCode,
	                  //mobile: this.realAuthFormModel.mobile,
	                  idno: this.realAuthFormModel.idno,
                    token: this.userInfo.token,
                    idCardFrontId: idCardFrontIdEnCode,
                    idCardBackId: idCardBackIdEnCode
	                }).then((res) => {
	                  if (Number(res.data.code) === 0) {
                      this.isSaving = false;
	                    /* this.setRealNameState(2);
	                    this.loading = false;
	                    this.setSuccessMessage({
	                      show: true,
	                      content: res.data.result
                      }); */
                      /* this.realNameSuccessModal.show = true;
                      this.realNameSuccessModal.content = "已打开实名认证页面，请完成操作后点击确定"; */
                      window.location.href = res.data.result;
	                  } else {
                      this.loading = false;
                      this.isSaving = false;
	                    this.setRealNameState(0);
	                    this.setFailMessage({
	                      show: true,
	                      content: res.data.result
                      });
	                  }
	                }).catch((res) => {
                    this.isSaving = false;
	                  this.loading = false;
	                });
              /*   } else {
                  this.setRealNameState(0);
                  this.setFailMessage({
                    show: true,
                    content: res.data.result
                  });
                }
              }).catch((res) => {
                this.loading = false;
              }); */
            } else if (Number(this.userInfo.crmCustomerType) === 2) {
              const codeSysfiled = this.sysFileIds ? encodeURIComponent(JSON.stringify(this.sysFileIds)) : '';
              const idCardFrontIdEnCode = this.idCardFrontId ? encodeURIComponent(JSON.stringify(this.idCardFrontId)) : '';
              const idCardBackIdEnCode = this.idCardBackId ? encodeURIComponent(JSON.stringify(this.idCardBackId)) : '';
              api.saveEnterpriseAuthInfo({
                token: this.userInfo.token,
                authId: this.enterpriseInfoFormModel.authId,
                customerId: this.userInfo.crmCustomerId,
                customerName: this.enterpriseInfoFormModel.customerName,
                enterpriseNumber: this.enterpriseInfoFormModel.enterpriseNumber,
                enterpriseOfficeAddress: this.enterpriseInfoFormModel.enterpriseOfficeAddress,
                enterpriseLegalUser: this.enterpriseInfoFormModel.enterpriseLegalUser,
                enterpriseLegalIdNo: this.enterpriseInfoFormModel.enterpriseLegalIdNo,
                enterpriseAgentUser: this.enterpriseInfoFormModel.enterpriseAgentUser,
                enterpriseAgentIdNo: this.enterpriseInfoFormModel.enterpriseAgentIdNo,
                enterpriseAgentContact: this.enterpriseInfoFormModel.enterpriseAgentContact,
                enterpriseLegalUserPhone: this.enterpriseInfoFormModel.enterpriseLegalUserPhone,
                enterpriseOrganizingNumber: this.enterpriseInfoFormModel.enterpriseOrganizingNumber,
                userType: this.enterpriseInfoFormModel.userType,
                registrationType: this.enterpriseInfoFormModel.registrationType,
                fileId: codeSysfiled,
                idCardFrontId: idCardFrontIdEnCode,
                idCardBackId: idCardBackIdEnCode
              }).then((res) => {
                this.isSaving = false;
                if (Number(res.data.code) === 0) {
                  /* this.setRealNameState(2);
                  this.setSuccessMessage({
                    show: true,
                    content: res.data.result
                  }); */
                  if(res.data.mode == "PRODUCT"){
                    window.location.href = res.data.result;
                  }else{
                    this.setSuccessMessage({
                      show: true,
                      content: res.data.result
                    });
                    setTimeout(() => {
                      //刷新当前页面
                      this.$router.go(0);
                    }, 500);                    
                  }
                } else {
                  this.setRealNameState(0);
                  this.setFailMessage({
                    show: true,
                    content: res.data.result
                  });
                }
              });
            }
          } else {
            return false;
          }
        });
      },

      //法人认证
      submitForm2 () {
        this.$refs.realAuthForm.validate((valid) => {
          if (valid) {
            this.loading = true;
            this.isSaving = true;
            const codeSysfiled = this.sysFileIds ? encodeURIComponent(JSON.stringify(this.sysFileIds)) : '';
            const idCardFrontIdEnCode = this.idCardFrontId ? encodeURIComponent(JSON.stringify(this.idCardFrontId)) : '';
            const idCardBackIdEnCode = this.idCardBackId ? encodeURIComponent(JSON.stringify(this.idCardBackId)) : '';
            api.saveEnterpriseAuthInfo({
              token: this.userInfo.token,
              authId: this.enterpriseInfoFormModel.authId,
              customerId: this.userInfo.crmCustomerId,
              customerName: this.enterpriseInfoFormModel.customerName,
              enterpriseNumber: this.enterpriseInfoFormModel.enterpriseNumber,
              enterpriseOfficeAddress: this.enterpriseInfoFormModel.enterpriseOfficeAddress,
              enterpriseLegalUser: this.enterpriseInfoFormModel.enterpriseLegalUser,
              enterpriseLegalIdNo: this.enterpriseInfoFormModel.enterpriseLegalIdNo,
              enterpriseAgentUser: this.enterpriseInfoFormModel.enterpriseAgentUser,
              enterpriseAgentIdNo: this.enterpriseInfoFormModel.enterpriseAgentIdNo,
              enterpriseAgentContact: this.enterpriseInfoFormModel.enterpriseAgentContact,
              enterpriseLegalUserPhone: this.enterpriseInfoFormModel.enterpriseLegalUserPhone,
              enterpriseOrganizingNumber: this.enterpriseInfoFormModel.enterpriseOrganizingNumber,
              userType: this.enterpriseInfoFormModel.userType,
              registrationType: this.enterpriseInfoFormModel.registrationType,
              fileId: codeSysfiled,
              idCardFrontId: idCardFrontIdEnCode,
              idCardBackId: idCardBackIdEnCode,
              legalInit: 'true'
            }).then((res) => {
              this.isSaving = false;
              if (Number(res.data.code) === 0) {
                if(res.data.mode == "PRODUCT"){
                  window.location.href = res.data.result;
                }else{
                  this.setSuccessMessage({
                    show: true,
                    content: res.data.result
                  });
                  setTimeout(() => {
                    //刷新当前页面
                    this.$router.go(0);
                  }, 500);                    
                }
              } else {
                this.setRealNameState(0);
                this.setFailMessage({
                  show: true,
                  content: res.data.result
                });
              }
            });
          } else {
            return false;
          }
        });
      },

      gotoLoan (text) {
        const that = this;

        this.$alert(text, ' ', {
          confirmButtonText: '确定',
          type: 'warning',
          beforeClose: (action, instance, done) => {
            that.$router.push({path: '/personalCenter/myLoan'});
            done();
          }
        });
      },
      selectCardNO (curr) {
        this.updateBankCardNum(curr);
      },
      getSMSCode () {
        // 由于签约号规则还没有确定
        // this.$refs.realAuthForm.validateField('cardno')
        this.$refs.realAuthForm.validateField('bankRegion');
        this.$refs.realAuthForm.validateField('bankName');
        // this.$refs.realAuthForm.validateField('bankNameValue')
        this.$refs.realAuthForm.validateField('bankBranchName');
        this.$refs.realAuthForm.validateField('bankAccountName');
        this.$refs.realAuthForm.validateField('mobile');
        this.$refs.realAuthForm.validateField('name');
        this.$refs.realAuthForm.validateField('idno');
        // this.$refs.realAuthForm.validateField('proNumber')
        // setTimeout(() => {
        //   const error = document.querySelectorAll('.el-form-item__error')
        if (this.$refs.region.validateState !== 'error' && this.$refs.bankName.validateState !== 'error' && this.$refs.branchName.validateState !== 'error' && this.$refs.accountName.validateState !== 'error' && this.$refs.mobile.validateState !== 'error' && this.$refs.name.validateState !== 'error' && this.$refs.idno.validateState !== 'error') {
          api.authPersonSMSCode({
            token: this.userInfo.token,
            customerId: this.userInfo.crmCustomerId,
              // proNumber: this.realAuthFormModel.proNumber,
            mobile: this.realAuthFormModel.mobile,
            bankAccount: this.realAuthFormModel.bankAccountName,
            bankAccountOwner: this.realAuthFormModel.name,
            idno: this.realAuthFormModel.idno,
            msgType: 0
          }).then((res) => {
            const resData = res.data;
            this.indexCode = resData.data;
            let countDownTime = 60;
            if (Number(resData.code) === 0) {
              this.isGetCode = false;
              const countDown = setInterval(() => {
                countDownTime -= 1;
                if (countDownTime !== 0) {
                  this.SMSCodeBtn = {
                    btnState: true,
                    text: `${countDownTime}秒后获取`
                  };
                } else {
                  this.SMSCodeBtn = {
                    btnState: false,
                    text: '获取验证码'
                  };
                  clearInterval(countDown);
                }
              }, 1000);
            } else {
              this.setFailMessage({
                show: true,
                content: resData.result
              });
            }
          });
        }
        // }, 500)
      },
      // -------------------------上传附件相关方法开始------------------------------
    //      删除附件
      deleteUploadedFile (file) {
        const fileIndex = _.findIndex(
        this.sysFileIds,
        item => item.fileId === file.fileId
      );
        this.sysFileIds.splice(fileIndex, 1);
      },
      deleteUploadedFile2 (file) {
        const fileIndex = _.findIndex(
        this.idCardFrontId,
        item => item.fileId === file.fileId
      );
        this.idCardFrontId.splice(fileIndex, 1);
      },
      deleteUploadedFile3 (file) {
        const fileIndex = _.findIndex(
        this.idCardBackId,
        item => item.fileId === file.fileId
      );
        this.idCardBackId.splice(fileIndex, 1);
      },

      uploadBeforeSend (obj, data) {
        (data.tokenId = localStorage.getItem('dl_tokenId_bl')),
        (this.isShowProgress = true);
      },
      uploadProgress (file, percent) {
        const _this = this;
        _this.progress = percent * 100;
      },
      uploadSuccess (file, res) {
        const _self = this;
        const arr = _.split(res, ':');
        this.sysFileIds.push({
          fileId: Number(arr[0].replace('sysFile=', '')),
          fileName: file.name,
          uploaderId: file.id // 上传文件id
        });
        this.progress = 0;
        this.isShowProgress = false;
      },
      uploadSuccess2 (file, res) {
        const _self = this;
        const arr = _.split(res, ':');
        this.idCardFrontId.push({
          fileId: Number(arr[0].replace('sysFile=', '')),
          fileName: file.name,
          uploaderId: file.id // 上传文件id
        });
        this.progress = 0;
        this.isShowProgress = false;
      },
      uploadSuccess3 (file, res) {
        const _self = this;
        const arr = _.split(res, ':');
        this.idCardBackId.push({
          fileId: Number(arr[0].replace('sysFile=', '')),
          fileName: file.name,
          uploaderId: file.id // 上传文件id
        });
        this.progress = 0;
        this.isShowProgress = false;
      },
      uploadSuccess4 (file, res) {
        const _self = this;
        const arr = _.split(res, ':');
        this.idCardFrontId.push({
          fileId: Number(arr[0].replace('sysFile=', '')),
          fileName: file.name,
          uploaderId: file.id // 上传文件id
        });
        this.progress = 0;
        this.isShowProgress = false;
      },
      uploadSuccess5 (file, res) {
        const _self = this;
        const arr = _.split(res, ':');
        this.idCardBackId.push({
          fileId: Number(arr[0].replace('sysFile=', '')),
          fileName: file.name,
          uploaderId: file.id // 上传文件id
        });
        this.progress = 0;
        this.isShowProgress = false;
      },            
      uploadError (file, reason) {
        if (reason === 'http') {
          this.setFailMessage({
            show: true,
            content: '上传出错！请更新浏览器到最新版本或使用谷歌浏览器上传！'
          });
        }
        this.uploader.removeFile(file, true);
        this.progress = 0;
        this.isShowProgress = false;
      },
      uploadValidata (type) {
        switch (type) {
          case 'F_DUPLICATE': // 是否重复
            this.setFailMessage({
              show: true,
              content: '该文件您已经上传过了，请不要重复上传！'
            });
            break;
          case 'Q_TYPE_DENIED': // 文件类型是否满足
            this.setFailMessage({
              show: true,
              content:
              '请上传后缀为.jpg，.gif，.bmp，.gif，.doc，.rar，.zip，.7z的文件'
            });
            break;
          case 'Q_EXCEED_SIZE_LIMIT': // 文件大小是否超出
            this.setFailMessage({
              show: true,
              content: '请上传大小不超过10M的文件'
            });
            break;
        }
      },

      createWebUploader () {
        this.uploader = Webuploader.create({
          auto: true, // 自动上传
          swf: './static/Uploader.swf',
          server: `${
          this.ajaxBaseUrl
        }/mobile/crmCustomerAttachInfoController/saveFile.ht`,
          pick: {
            id: '#picker',
            multiple: true
          },
          chunked: true,
          duplicate: true, // 去重
          fileSizeLimit: 1024 * 1024 * 10,
          accept: {
            title: '*',
            extensions: 'gif,jpg,jpeg,png',
            mimeTypes:
            'image/*'
          }
        });
        this.uploader.on('uploadBeforeSend', this.uploadBeforeSend);
        this.uploader.on('uploadProgress', this.uploadProgress);
        this.uploader.on('uploadSuccess', this.uploadSuccess);
        this.uploader.on('uploadError', this.uploadError);
        this.uploader.on('error', this.uploadValidata);
      },
      /*
       身份证正面
       */
      createWebUploader2 () {
        this.uploader = Webuploader.create({
          auto: true, // 自动上传
          swf: './static/Uploader.swf',
          server: `${
          this.ajaxBaseUrl
        }/mobile/crmCustomerAttachInfoController/saveFile.ht`,
          pick: {
            id: '#reder',
            multiple: true
          },
          chunked: true,
          duplicate: true, // 去重
          fileSizeLimit: 1024 * 1024 * 10,
          accept: {
            title: '*',
            extensions: 'gif,jpg,jpeg,png',
            mimeTypes:
            'image/*'
          }
        });
        this.uploader.on('uploadBeforeSend', this.uploadBeforeSend);
        this.uploader.on('uploadProgress', this.uploadProgress);
        this.uploader.on('uploadSuccess', this.uploadSuccess2);
        this.uploader.on('uploadError', this.uploadError);
        this.uploader.on('error', this.uploadValidata);
      },
       /*
       身份证反面
       */
      createWebUploader3 () {
        this.uploader = Webuploader.create({
          auto: true, // 自动上传
          swf: './static/Uploader.swf',
          server: `${
          this.ajaxBaseUrl
        }/mobile/crmCustomerAttachInfoController/saveFile.ht`,
          pick: {
            id: '#reder2',
            multiple: true
          },
          chunked: true,
          duplicate: true, // 去重
          fileSizeLimit: 1024 * 1024 * 10,
          accept: {
            title: '*',
            extensions: 'gif,jpg,jpeg,png',
            mimeTypes:
            'image/*'
          }
        });
        this.uploader.on('uploadBeforeSend', this.uploadBeforeSend);
        this.uploader.on('uploadProgress', this.uploadProgress);
        this.uploader.on('uploadSuccess', this.uploadSuccess3);
        this.uploader.on('uploadError', this.uploadError);
        this.uploader.on('error', this.uploadValidata);
      },

      createWebUploader4 () {
        this.uploader = Webuploader.create({
          auto: true, // 自动上传
          swf: './static/Uploader.swf',
          server: `${
          this.ajaxBaseUrl
        }/mobile/crmCustomerAttachInfoController/saveFile.ht`,
          pick: {
            id: '#reder3',
            multiple: true
          },
          chunked: true,
          duplicate: true, // 去重
          fileSizeLimit: 1024 * 1024 * 10,
          accept: {
            title: '*',
            extensions: 'gif,jpg,jpeg,png',
            mimeTypes:
            'image/*'
          }
        });
        this.uploader.on('uploadBeforeSend', this.uploadBeforeSend);
        this.uploader.on('uploadProgress', this.uploadProgress);
        this.uploader.on('uploadSuccess', this.uploadSuccess4);
        this.uploader.on('uploadError', this.uploadError);
        this.uploader.on('error', this.uploadValidata);
      }, 
      createWebUploader5 () {
        this.uploader = Webuploader.create({
          auto: true, // 自动上传
          swf: './static/Uploader.swf',
          server: `${
          this.ajaxBaseUrl
        }/mobile/crmCustomerAttachInfoController/saveFile.ht`,
          pick: {
            id: '#reder4',
            multiple: true
          },
          chunked: true,
          duplicate: true, // 去重
          fileSizeLimit: 1024 * 1024 * 10,
          accept: {
            title: '*',
            extensions: 'gif,jpg,jpeg,png',
            mimeTypes:
            'image/*'
          }
        });
        this.uploader.on('uploadBeforeSend', this.uploadBeforeSend);
        this.uploader.on('uploadProgress', this.uploadProgress);
        this.uploader.on('uploadSuccess', this.uploadSuccess5);
        this.uploader.on('uploadError', this.uploadError);
        this.uploader.on('error', this.uploadValidata);
      }          
      // -------------------------上传附件相关方法结束------------------------------
  
    },
    mounted () {
      if (this.uploader == undefined) {
        const _this = this;
        setTimeout(() => {
          _this.createWebUploader();
          _this.createWebUploader2();
          _this.createWebUploader3();
          _this.createWebUploader4();
          _this.createWebUploader5();
          _this.uploader.refresh();
        }, 500);
      };

      //获取返回参数，更新状态
      var status = this.$route.query.status;
      if(1==2){
        //更新实名认证状态
        api.realNameNotify({
	                  success: status,
	                  userId: this.userInfo.crmCustomerId
	      }).then((res) => {
          if (Number(this.userInfo.crmCustomerType) === 1) {
            this.getRealNameAuthData({
             token: this.userInfo.token,
             crmCustomerType: this.userInfo.crmCustomerType
           }).then((res) => {
             const data = res.data;
             this.setRealNameState(Number(data.code));
             this.idCardFrontId = res.data.result.BankAuthApply.idCardFrontId
                 ? JSON.parse(res.data.result.BankAuthApply.idCardFrontId.replace(/\'/g, '"'))
                 : [];
             this.idCardBackId = res.data.result.BankAuthApply.idCardBackId
                 ? JSON.parse(res.data.result.BankAuthApply.idCardBackId.replace(/\'/g, '"'))
                 : [];
             if (Number(data.code) === 0) {
               this.auditState = data.result.auditState;
               if (Number(data.result.isAuth) == 1) {
                 this.isAuth = true;
               }
               if (Number(data.result.auditState) == -1 || Number(data.result.auditState) == 1) {
                 this.isEditable = true;
                 this.canDel = false;
               } else {
                 this.canDel = true;
                 this.isEditable = false;
               }
               this.setRealNameAuthInfo(res.data.result);
               this.getCityAndDistrictData({
                 val: [this.realAuthFormModel.bankRegion[0]]
               }).then(() => {
                 this.getCityAndDistrictData({
                   val: [this.realAuthFormModel.bankRegion[0], this.realAuthFormModel.bankRegion[1]]
                 }).then(() => {
                 // _this.arr = [bankcard.bankProvince, bankcard.bankCity, bankcard.bankCounty]
                 });
               });
             }
           }); 
          } else if (Number(this.userInfo.crmCustomerType) === 2) {
              api.getEnterpriseAuthInfo({
                token: this.userInfo.token
              }).then((res) => {
                const result = res.data;
                const data = res.data.data;
                this.sysFileIds = data.payReqEntity.fileId
                    ? JSON.parse(data.payReqEntity.fileId.replace(/\'/g, '"'))
                    : [];
                this.idCardFrontId = data.payReqEntity.idCardFrontId
                    ? JSON.parse(data.payReqEntity.idCardFrontId.replace(/\'/g, '"'))
                    : [];
                this.idCardBackId = data.payReqEntity.idCardBackId
                    ? JSON.parse(data.payReqEntity.idCardBackId.replace(/\'/g, '"'))
                    : [];                    
                this.setRealNameState(Number(result.code));
                if (Number(result.code) === 0 || Number(result.code) === 3 || Number(result.code) === 2) {
                  if (Number(data.payReqEntity.isAuth) !== 1) {
                    this.isAuth = false;
                  }
                  this.enterpriseInfoFormModel = {
                    authId: (data.payReqEntity.authId != null ? data.payReqEntity.authId : ''),
                    customerName: (data.payReqEntity.customerName != null ? data.payReqEntity.customerName : ''),
                    enterpriseNumber: (data.payReqEntity.enterpriseNumber != null ? data.payReqEntity.enterpriseNumber : ''),
                    enterpriseOfficeAddress: (data.payReqEntity.enterpriseOfficeAddress != null ? data.payReqEntity.enterpriseOfficeAddress : ''),
                    enterpriseLegalUser: (data.payReqEntity.enterpriseLegalUser != null ? data.payReqEntity.enterpriseLegalUser : ''),
                    enterpriseLegalIdNo: (data.payReqEntity.enterpriseLegalIdNo != null ? data.payReqEntity.enterpriseLegalIdNo : ''),
                    enterpriseAgentUser: (data.payReqEntity.enterpriseAgentUser != null ? data.payReqEntity.enterpriseAgentUser : ''),
                    enterpriseAgentIdNo: (data.payReqEntity.enterpriseAgentIdNo != null ? data.payReqEntity.enterpriseAgentIdNo : ''),
                    enterpriseAgentContact: (data.payReqEntity.enterpriseAgentContact != null ? data.payReqEntity.enterpriseAgentContact : ''),
                    enterpriseLegalUserPhone: (data.payReqEntity.enterpriseLegalUserPhone != null ? data.payReqEntity.enterpriseLegalUserPhone : ''),
                    userType: (data.payReqEntity.userType != null ? Number(data.payReqEntity.userType) : 2),
                    registrationType: (data.payReqEntity.registrationType != null ? Number(data.payReqEntity.registrationType) : 1),
                    enterpriseOrganizingNumber: (data.payReqEntity.enterpriseOrganizingNumber != null ? data.payReqEntity.enterpriseOrganizingNumber : ''),
                    province: (data.payReqEntity.province != null ? data.payReqEntity.province : ''),
                    city: (data.payReqEntity.city != null ? data.payReqEntity.city : ''),
                    enterpriseScale: (data.payReqEntity.enterpriseScale != null ? data.payReqEntity.enterpriseScale : ''),
                    enterpriseIndustry: (data.payReqEntity.enterpriseIndustry != null ? data.payReqEntity.enterpriseIndustry : '')
                  };
                  this.provinceCode = (this.enterpriseInfoFormModel.province != null ? this.enterpriseInfoFormModel.province : '');
                  this.approvalInfo = data.payReqEntity.approvalInfo;
                  if (Number(result.code) === 2) {
                    this.setRealNameState(2);
                  }
                  if (this.stateCode == 0 || this.stateCode == 1) {
                    this.isEditable = false;
                    this.canDel = true;
                  } else {
                    this.canDel = false;
                    this.isEditable = true;
                  }
                }
              });
            }
        });
      }else{
        //this.getProvinceData();
        
        if (Number(this.userInfo.crmCustomerType) === 1) {
        this.getRealNameAuthData({
            token: this.userInfo.token,
            crmCustomerType: this.userInfo.crmCustomerType
          }).then((res) => {
            const data = res.data;
            this.setRealNameState(Number(data.code));
            this.idCardFrontId = res.data.result.BankAuthApply.idCardFrontId
                ? JSON.parse(res.data.result.BankAuthApply.idCardFrontId.replace(/\'/g, '"'))
                : [];
            this.idCardBackId = res.data.result.BankAuthApply.idCardBackId
                ? JSON.parse(res.data.result.BankAuthApply.idCardBackId.replace(/\'/g, '"'))
                : [];
            if (Number(data.code) === 0) {
              this.auditState = data.result.auditState;
              if (Number(data.result.isAuth) == 1) {
                this.isAuth = true;
              }
              if (Number(data.result.auditState) == -1 || Number(data.result.auditState) == 1) {
                this.isEditable = true;
                this.canDel = false;
              } else {
                this.canDel = true;
                this.isEditable = false;
              }
              this.setRealNameAuthInfo(res.data.result);
              this.getCityAndDistrictData({
                val: [this.realAuthFormModel.bankRegion[0]]
              }).then(() => {
                this.getCityAndDistrictData({
                  val: [this.realAuthFormModel.bankRegion[0], this.realAuthFormModel.bankRegion[1]]
                }).then(() => {
                // _this.arr = [bankcard.bankProvince, bankcard.bankCity, bankcard.bankCounty]
                });
              });
            }
          });
        } else if (Number(this.userInfo.crmCustomerType) === 2) {
          api.getEnterpriseAuthInfo({
            token: this.userInfo.token
          }).then((res) => {
            const result = res.data;
            const data = res.data.data;
            this.sysFileIds = data.payReqEntity.fileId
                ? JSON.parse(data.payReqEntity.fileId.replace(/\'/g, '"'))
                : [];
            this.idCardFrontId = data.payReqEntity.idCardFrontId
                ? JSON.parse(data.payReqEntity.idCardFrontId.replace(/\'/g, '"'))
                : [];
            this.idCardBackId = data.payReqEntity.idCardBackId
                ? JSON.parse(data.payReqEntity.idCardBackId.replace(/\'/g, '"'))
                : []; 
            this.setRealNameState(Number(result.code));
            if (Number(result.code) === 0 || Number(result.code) === 3 || Number(result.code) === 2 || Number(result.code) === 1) {
              if (Number(data.payReqEntity.isAuth) !== 1) {
                this.isAuth = false;
              }
              this.enterpriseInfoFormModel = {
                authId: (data.payReqEntity.authId != null ? data.payReqEntity.authId : ''),
                customerName: (data.payReqEntity.customerName != null ? data.payReqEntity.customerName : ''),
                enterpriseNumber: (data.payReqEntity.enterpriseNumber != null ? data.payReqEntity.enterpriseNumber : ''),
                enterpriseOfficeAddress: (data.payReqEntity.enterpriseOfficeAddress != null ? data.payReqEntity.enterpriseOfficeAddress : ''),
                enterpriseLegalUser: (data.payReqEntity.enterpriseLegalUser != null ? data.payReqEntity.enterpriseLegalUser : ''),
                enterpriseLegalIdNo: (data.payReqEntity.enterpriseLegalIdNo != null ? data.payReqEntity.enterpriseLegalIdNo : ''),
                enterpriseAgentUser: (data.payReqEntity.enterpriseAgentUser != null ? data.payReqEntity.enterpriseAgentUser : ''),
                enterpriseAgentIdNo: (data.payReqEntity.enterpriseAgentIdNo != null ? data.payReqEntity.enterpriseAgentIdNo : ''),
                enterpriseAgentContact: (data.payReqEntity.enterpriseAgentContact != null ? data.payReqEntity.enterpriseAgentContact : ''),
                enterpriseLegalUserPhone: (data.payReqEntity.enterpriseLegalUserPhone != null ? data.payReqEntity.enterpriseLegalUserPhone : ''),
                userType: (data.payReqEntity.userType != null ? Number(data.payReqEntity.userType) : 2),
                registrationType: (data.payReqEntity.registrationType != null ? Number(data.payReqEntity.registrationType) : 1),
                enterpriseOrganizingNumber: (data.payReqEntity.enterpriseOrganizingNumber != null ? data.payReqEntity.enterpriseOrganizingNumber : ''),
                province: (data.payReqEntity.province != null ? data.payReqEntity.province : ''),
                city: (data.payReqEntity.city != null ? data.payReqEntity.city : ''),
                enterpriseScale: (data.payReqEntity.enterpriseScale != null ? data.payReqEntity.enterpriseScale : ''),
                enterpriseIndustry: (data.payReqEntity.enterpriseIndustry != null ? data.payReqEntity.enterpriseIndustry : '')
              };
              this.approvalInfo = data.payReqEntity.approvalInfo;
              this.provinceCode = (this.enterpriseInfoFormModel.province != null ? this.enterpriseInfoFormModel.province : '');
              if (Number(result.code) === 2) {
                this.setRealNameState(2);
              }
              if (this.stateCode == 0) {
                this.isEditable = false;
                this.canDel = true;
              } else {
                this.canDel = false;
                this.isEditable = true;
              }
            }
          });
        }
      }
      //this.getProvinceList();
      //this.getBelongIndustryList();
      //this.getCorporationscaleList();
    }
  };
</script>
<style lang="scss">
  .tips_info{
    line-height: 1.1;
  }
  .personal-center-form__alreadyAuth {
    margin-bottom: 25px;
    height: 40px;
    background: $lightWaterBlue;
  }

  .personal-center-form__alreadyAuth.is-disabled, .personal-center-form__alreadyAuth.is-disabled:hover {
    color: #fff;
    background-color: #c6c6c6;
  }

  //短信验证码
  .SMS-cont {
    position: relative;

    .el-button-sms-code {
      background: #00C0FF;
      position: absolute;
      right: 7px;
      top: 7px;
    }

    .el-button-sms-code.is-disabled {
      background: #DCDCDC;
    }
  }
  #picker > div {
    background-image:url('../../../static/images/businessLicenseBackGround.png');
    background-repeat:no-repeat;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
  } 
  #reder{
    background-image:url('../../../static/images/sfzf.jpg');
    background-repeat:no-repeat;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
  }
  #reder2{
    background-image:url('../../../static/images/sfzz.jpg');
    background-repeat:no-repeat;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
  }
  #reder3{
    background-image:url('../../../static/images/sfzf.jpg');
    background-repeat:no-repeat;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
  }
  #reder4{
    background-image:url('../../../static/images/sfzz.jpg');
    background-repeat:no-repeat;
    background-size:100% 100%;
    -moz-background-size:100% 100%;
  }  
.file-list__item-list1 li:nth-child(1) {
    margin-top: 0;
    // width: 80%;
    margin-left: -45%;
}
.file-list__item-list2 { 
  li:nth-child(1){
    // width: 90%;
    margin-left: 55%;
    margin-top: -44%;
  }
 
}
.file-list__item-preview2 {
    position: relative;
    box-sizing: border-box;
    display: block;
    border-radius: 5px;
    width: 270px;
    height: 200px;
    overflow: hidden;
    border: 1px dashed #ff8b38;
    background-color: #fff;
    background-repeat: no-repeat;
    background-size: cover;
    &:hover .file-list__item-delete {
    display: block;
  }

  img {
    width:100%;
    height: 100%;
  }
}
.file-list__item-preview img {
    width: 100%;
    height: 100%;
}
.file-list__select-file2 {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -ms-box-sizing: border-box;
  -moz-box-sizing: border-box;
  padding:0;
  position: relative;
  background-color: #f4f4f4;
  cursor: pointer;

  .picker{
    width:100%;
    height:100%;
  }
  .webuploader-pick{
    position: relative;
    display: inline-block;
    cursor: pointer;
    width: 240px;
    height: 180px;
    background: #00b7ee;
    opacity: 0;
    padding: 10px 15px;
    color: #fff;
    text-align: center;
    border-radius: 3px;
    overflow: hidden;
  }
}
</style>




// WEBPACK FOOTER //
// RealNameAuth.vue?4c3dff5a